'use strict';

exports.__esModule = true;

var _styledBase = require('@emotion/styled-base');

var _styledBase2 = _interopRequireDefault(_styledBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Title = ( /*#__PURE__*/0, _styledBase2.default)('h2', {
	target: 'e1hnx4sx0',
	label: 'Title'
})('margin:0 0 8px;font-size:1rem;color:', function (_ref) {
	var theme = _ref.theme;
	return theme.colors.titleColor;
}, ';' + (process.env.NODE_ENV === 'production' ? '' : '/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9zdHlsZXMvVGl0bGUuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBRTBCIiwiZmlsZSI6Ii4uLy4uL3NyYy9zdHlsZXMvVGl0bGUuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCc7XG5cbmNvbnN0IFRpdGxlID0gc3R5bGVkKCdoMicpYFxuXHRtYXJnaW46IDAgMCA4cHg7XG5cdGZvbnQtc2l6ZTogMXJlbTtcblx0Y29sb3I6ICR7KHsgdGhlbWUgfSkgPT4gdGhlbWUuY29sb3JzLnRpdGxlQ29sb3J9O1xuYDtcblxuZXhwb3J0IGRlZmF1bHQgVGl0bGU7XG4iXX0= */'));

exports.default = Title;